import React, { memo } from 'react';
import { Typography } from '@material-ui/core';
import { formatNumber } from 'UI/utils';

import { useMessageMetaDataStyles } from './MessageMetaData.styled';

export const MessageMetaData = memo(({ data, onClick, isActive }) => {
  const classes = useMessageMetaDataStyles({ isActive });

  const handleClick = () => {
    onClick(data?.id);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  if (!data) return null;

  return (
    <div
      className={classes.metaDataContainer}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <Typography variant="subtitle2">{formatNumber(data.contacts)} contacts found</Typography>
      <Typography variant="body2">{data.description}</Typography>
    </div>
  );
});
